export const SALT_FOR_ACCOUNT = "w$rh8g[jYN%Ql8E[";
export const KEY_FOR_ACCOUNT = "bRqAhrV@wyLqj&oQ";
